import React from "react"

import { FloorRemarkInput } from "./inputs/FloorRemarkInput"

export const FloorFormRemarkTab = React.memo(() => {
  return (
    <div className="floor-form-remark-tab floor-form__tab-content">
      <FloorRemarkInput />
    </div>
  )
})
